module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container"
  }, [(!_vm.isLandingPage) ? _c('navbar') : _vm._e(), _vm._v(" "), _c('vue-toast', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLandingPage),
      expression: "!isLandingPage"
    }],
    ref: "infoToast"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), (!_vm.isLandingPage) ? _c('overlay') : _vm._e(), _vm._v(" "), _c('cookie-bar'), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f65258d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 957
// module chunks = 0